/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_4Inputs */

const da_privacy_purpose_4 = /** @type {(inputs: Privacy_Purpose_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om dig og kontakt om feedback: dit samtykke, som du kan trække tilbage ved at ændre eller fjerne oplysningerne (art. 6, stk. 1, litra a).`)
};

/** @type {(inputs: Privacy_Purpose_4Inputs) => LocalizedString} */
const en_privacy_purpose_4 = da_privacy_purpose_4;

/**

* @param {Privacy_Purpose_4Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_4 = /** @type {((inputs?: Privacy_Purpose_4Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_4Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_4(inputs)
	return /** @type {LocalizedString} */ ("Om dig og kontakt om feedback: dit samtykke, som du kan trække tilbage ved at ændre eller fjerne oplysningerne (art. 6, stk. 1, litra a).")
});